import React from 'react';
import styles from './NtrpRangeFilter.module.css';

const LEVELS = [1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5];

const TIERS = [
    { label: 'Rekreacyjny', edges: [0, 3.5], variant: 'tier1' },
    { label: 'Średniozaawansowany', edges: [3.5, 6.5], variant: 'tier2' },
    { label: 'Zaawansowany', edges: [6.5, 9], variant: 'tier3' },
];

const pct = (v) => (v / (LEVELS.length - 1)) * 100;

const NtrpRangeFilter = ({ minIdx, maxIdx, onChange, matchCount, totalCount }) => {
    const min = LEVELS[minIdx];
    const max = LEVELS[maxIdx];
    const isFullRange = minIdx === 0 && maxIdx === LEVELS.length - 1;

    const handleMinChange = (e) => {
        const v = Number(e.target.value);
        onChange(Math.min(v, maxIdx), maxIdx);
    };
    const handleMaxChange = (e) => {
        const v = Number(e.target.value);
        onChange(minIdx, Math.max(v, minIdx));
    };
    const reset = () => onChange(0, LEVELS.length - 1);

    const leftPct = pct(minIdx);
    const rightPct = pct(maxIdx);

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.title}>
                    <span className={styles.badge}>NTRP</span>
                    <span className={styles.range}>
                        {isFullRange ? 'Wszystkie poziomy' : `${min.toFixed(1)} – ${max.toFixed(1)}`}
                    </span>
                </div>
                <div className={styles.count}>
                    {isFullRange ? (
                        <>{totalCount} {totalCount === 1 ? 'oferta' : 'ofert'}</>
                    ) : (
                        <><strong>{matchCount}</strong> z {totalCount} ofert</>
                    )}
                </div>
            </div>

            <div className={styles.sliderBlock}>
                <div className={styles.track}>
                    <div className={styles.tiers} aria-hidden="true">
                        {TIERS.map((t) => (
                            <div
                                key={t.variant}
                                className={`${styles.tier} ${styles[t.variant]}`}
                                style={{
                                    left: `${pct(t.edges[0])}%`,
                                    right: `${100 - pct(t.edges[1])}%`,
                                }}
                            />
                        ))}
                    </div>

                    <div
                        className={styles.activeRange}
                        style={{ left: `${leftPct}%`, right: `${100 - rightPct}%` }}
                    />

                    <div className={styles.bubble} style={{ left: `${leftPct}%` }}>
                        {min.toFixed(1)}
                    </div>
                    <div className={styles.bubble} style={{ left: `${rightPct}%` }}>
                        {max.toFixed(1)}
                    </div>

                    <input
                        type="range"
                        min={0}
                        max={LEVELS.length - 1}
                        step={1}
                        value={minIdx}
                        onChange={handleMinChange}
                        className={styles.rangeInput}
                        aria-label="Minimalny poziom NTRP"
                    />
                    <input
                        type="range"
                        min={0}
                        max={LEVELS.length - 1}
                        step={1}
                        value={maxIdx}
                        onChange={handleMaxChange}
                        className={styles.rangeInput}
                        aria-label="Maksymalny poziom NTRP"
                    />

                    <div className={styles.ticks} aria-hidden="true">
                        {LEVELS.map((lvl, i) => {
                            const active = i >= minIdx && i <= maxIdx;
                            return (
                                <div
                                    key={lvl}
                                    className={`${styles.tick} ${active ? styles.tickActive : ''}`}
                                    style={{ left: `${pct(i)}%` }}
                                >
                                    <span className={styles.tickLabel}>{lvl.toFixed(1)}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {!isFullRange && (
                    <div className={styles.legend}>
                        <button type="button" className={styles.reset} onClick={reset}>
                            Wyczyść filtr
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export { LEVELS as NTRP_LEVELS };
export default NtrpRangeFilter;
